import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { useInterval } from 'react-use'

import { useMarket } from 'src/hooks/useMarket'

import {
  JET_IFRAME_RENDER_CHECK_INTERVAL,
  JET_IFRAME_RENDER_CHECK_TRIES,
  CONFIRM_BUTTON_SUBMIT_VARIANT,
  CHANGE_CREDIT_CARD_BUTTON_SUBMIT_VARIANT,
} from './constants'
import { JetIframeFormBase } from './styles'

import JetIframeForm from '.'
import Loader from 'src/comps/Atom/Loader'
import { report } from 'src/utils/clientErrorReporter'

const JetIframeFormContainer = ({
  providerId,
  purchaseId,
  onSuccess,
  disabled = false,
  submitCopy = CONFIRM_BUTTON_SUBMIT_VARIANT,
  customSubmit,
  onBeforeSubmit,
}) => {
  const { language } = useMarket()
  const SCRIPT_URL = `https://api.paycomet.com/gateway/paycomet.jetiframe.js?lang=${language}`

  const [iframeStatusCheck, setIframeStatusCheck] = useState({
    timeout: JET_IFRAME_RENDER_CHECK_INTERVAL,
    tries: JET_IFRAME_RENDER_CHECK_TRIES,
    display: true,
  })

  function stopIframeStatusCheck() {
    setIframeStatusCheck({ ...iframeStatusCheck, tries: 0, timeout: null })
  }

  function resetIframe() {
    setIframeStatusCheck({ ...iframeStatusCheck, display: false })
  }

  useInterval(() => {
    const creditCardNumberInputs = document.querySelectorAll('#paycomet-pan > iframe').length
    const cvcInputs = document.querySelectorAll('#paycomet-cvc2 > iframe').length
    const remainingTries = iframeStatusCheck.tries - 1

    if ((creditCardNumberInputs > 1 || cvcInputs > 1) && remainingTries > 1) {
      resetIframe()
    }

    if (creditCardNumberInputs > 1 && remainingTries < 1) {
      report(new Error('Too many rendered CreditCard fields'))
    }

    if (cvcInputs > 1 && remainingTries < 1) {
      report(new Error('Too many rendered CVC fields'))
    }

    if (remainingTries < 1) {
      stopIframeStatusCheck()
      return
    }

    setIframeStatusCheck({ ...iframeStatusCheck, tries: remainingTries, display: true })
  }, iframeStatusCheck.timeout)

  return (
    <JetIframeFormBase data-testid="jet-iframe-form">
      {iframeStatusCheck.display ? (
        <JetIframeForm
          providerId={providerId}
          purchaseId={purchaseId}
          onSuccess={onSuccess}
          disabled={disabled}
          submitCopy={submitCopy}
          scriptUrl={SCRIPT_URL}
          resetCallback={resetIframe}
          customSubmit={customSubmit}
          onBeforeSubmit={onBeforeSubmit}
        />
      ) : (
        <Loader />
      )}
    </JetIframeFormBase>
  )
}

JetIframeFormContainer.propTypes = {
  providerId: PropTypes.string.isRequired,
  purchaseId: PropTypes.string.isRequired,
  onSuccess: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  submitCopy: PropTypes.oneOf([
    CONFIRM_BUTTON_SUBMIT_VARIANT,
    CHANGE_CREDIT_CARD_BUTTON_SUBMIT_VARIANT,
  ]),
  onBeforeSubmit: PropTypes.func,
  customSubmit: PropTypes.bool,
}

export default JetIframeFormContainer
